import { VERIFICATION_RESULT } from '../../constants';
import { getAdapters } from './getAdapters';
import { getVerificationData } from './getVerificationData';
import { getAuthorization } from './getAuthorization';
/**
 * Returns the ID&V-authorized JWT for the given subject.
 */
export function getIdentityVerifiedAuthorization(identityVerifiedInstances, subject) {
    const instance = identityVerifiedInstances.find(({ authenticationSubject }) => {
        return authenticationSubject === subject;
    });
    const verifiedAdapter = getAdapters(instance).find(({ isIdentityVerificationPerformed }) => isIdentityVerificationPerformed);
    if (verifiedAdapter) {
        const verificationData = getVerificationData([verifiedAdapter], {
            verificationResults: VERIFICATION_RESULT.VERIFIED
        });
        return getAuthorization(verificationData);
    }
}
